module.exports = __webpack_public_path__ + "static/media/biglow-woodcraft5.6dc1d2e9.jpg";